import React from "react";
import { Link } from "react-router-dom";
import Frame from "../components/Frame";

export const About = () => {
  return (
    <div className="sc-page sc-page-about" data-testid="page-about">
      <Frame as="section" className="sc-page-hero" testId="about-hero">
        <span className="sc-section-eyebrow">OUR STORY</span>
        <h1 className="sc-page-title">
          Creating events designed to leave
          <br />
          a lasting impression.
        </h1>
        <p className="sc-page-sub">
          Sunstate Collective is a Queensland-based event planning and styling
          company specialising in luxury events, refined styling, and seamless
          coordination for both intimate occasions and large-scale celebrations.
        </p>
      </Frame>

      <Frame as="section" className="sc-about-grid" testId="about-content">
        <div className="sc-about-text">
          <span className="sc-section-eyebrow">WHO WE ARE</span>
          <h2 className="sc-section-title">
            Curated events.
            <br />
            Elevated experiences.
          </h2>
          <p>
            Sunstate Collective is a luxury event planning and styling company
            dedicated to creating refined, memorable experiences for every
            occasion.
          </p>
          <p>
            Born on the Gold Coast and servicing Gold Coast and Brisbane, we
            specialise in thoughtfully curated events that combine elevated
            styling, seamless coordination, and meticulous attention to detail.
          </p>
          <p>
            From intimate celebrations and luxury hotel transformations to
            corporate functions and large-scale events, every experience is
            designed to feel effortless, sophisticated, and unforgettable.
          </p>
        </div>

        <div className="sc-about-image">
          <div
            className="sc-about-photo"
            style={{
              backgroundImage: "url(/sunstate/gallery/home-pink-1.jpg)",
            }}
            aria-hidden="true"
          />
        </div>
      </Frame>

      <Frame as="section" className="sc-values" testId="about-values">
        <header className="sc-section-head">
          <span className="sc-section-eyebrow">OUR VALUES</span>
          <h2 className="sc-section-title">What we stand for</h2>
        </header>
        <div className="sc-values-grid">
          <div className="sc-value">
            <span className="sc-value-num">01</span>
            <h3>Considered Styling</h3>
            <p>
              Beautiful design begins with thoughtful detail. Every element
              has a reason, every palette a purpose.
            </p>
          </div>
          <div className="sc-value">
            <span className="sc-value-num">02</span>
            <h3>Transparent Pricing</h3>
            <p>
              No hidden fees, no surprises. You see exactly what&rsquo;s
              included, every step of the way.
            </p>
          </div>
          <div className="sc-value">
            <span className="sc-value-num">03</span>
            <h3>Personal Service</h3>
            <p>
              You speak directly with us. We answer quickly, plan carefully
              and execute precisely.
            </p>
          </div>
          <div className="sc-value">
            <span className="sc-value-num">04</span>
            <h3>Boutique by Design</h3>
            <p>
              We take on a limited number of events each month so every one
              receives our full attention.
            </p>
          </div>
        </div>
      </Frame>

      <Frame as="section" className="sc-cta" testId="about-cta">
        <h2 className="sc-cta-title">Let&rsquo;s plan something beautiful</h2>
        <p className="sc-cta-sub">
          Begin your enquiry and we&rsquo;ll be in touch within 48 hours with
          a tailored proposal.
        </p>
        <div className="sc-cta-btns">
          <Link to="/events" className="sc-btn-primary">
            BEGIN AN ENQUIRY
          </Link>
          <Link to="/contact" className="sc-btn-ghost">
            CONTACT US
          </Link>
        </div>
      </Frame>
    </div>
  );
};

export default About;
